import { Box, Dialog, DialogActions, DialogContent, Typography, useTheme } from '@mui/material';
import React, { useCallback } from 'react';
import { feedback } from '../../../services';
import { Button } from '../../MUI/button/Button';

interface DeleteConfirmationDialogProps {
  open: boolean;
  isLoading: boolean;
  label?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({ open, isLoading, label, onClose, onConfirm }) => {
  const theme = useTheme();

  const handleConfirm = useCallback(async () => {
    try {
      onConfirm();
      onClose();
    } catch (error) {
      feedback('Erro ao deletar registro.', 'error');
    }
  }, [onConfirm, onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          animation: 'slideUp 0.25s ease',
          borderRadius: 4,
          background: theme.palette.mode === 'dark' ? '#161b22' : '#ffffff',
          border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
        },
      }}
      sx={{
        '& .MuiBackdrop-root': {
          backdropFilter: 'blur(4px)',
        },
      }}
    >
      <DialogContent sx={{ pb: 2, pt: 3, px: 3 }}>
        <Typography sx={{ fontWeight: 500 }}>{label ?? 'Tem certeza que deseja deletar este registro?'}</Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Box display='flex' justifyContent='center' flex={1} gap={1}>
          <Button borderRounded={false} color='secondary' label='Não' onClick={onClose} data-testid='btn-confirm-delete-no' />
          <Button borderRounded={false} color='secondary' label='Sim' onClick={handleConfirm} isLoading={isLoading} data-testid='btn-confirm-delete-yes' />
        </Box>
      </DialogActions>
    </Dialog>
  );
};
